


























import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Footer extends Vue {
mapLink = 'https://www.google.com/maps/place/701+Brazos+St,+Austin,+TX+78701/@30.2688755,-97.7427528,17z/data=!3m1!4b1!4m5!3m4!1s0x8644b5a76b09dd7f:0x796a12bb9db613d2!8m2!3d30.2688755!4d-97.7405641'
}
